import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import { GGBLogoBasic } from 'assets/images'

const LoginFooter = styled.footer`
  background: linear-gradient(180deg, rgba(41, 41, 41, 0.4) 0%, rgba(41, 41, 41, 0) 100%);
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 40px 0;
`

const UserRouteFooter = styled.footer`
  background: ${(props) => props.theme.customPalette.light};
  color: ${(props) => props.theme.customPalette.footer};
  width: 100%;
  height: 72px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

const TextContainer = styled.div`
  color: ${(props) => props.theme.customPalette.navText};
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  padding-right: 127px;
  text-transform: uppercase;

  @media (max-width: 800px) {
    padding-right: 20px;
  }
`

const Container = styled.div`
  color: ${(props) => props.theme.customPalette.footer};
  max-width: 600px;
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;

  & > img {
    width: 167px;
  }
`

const LinkList = styled.ul`
  margin-top: 22px;
  margin-bottom: 0;
  list-style: none;
  padding: 0;
  font-weight: 300;
  display: flex;
  column-gap: 50px;
  row-gap: 10px;
  flex-wrap: wrap;
  justify-content: center;

  & > li {
    display: inline-block;

    & > a {
      color: ${(props) => props.theme.customPalette.mediumGray};
      text-decoration: underline;
      font-size: 14px;

      &:hover {
        text-decoration: none;
      }
    }
  }
`

interface Props {
  isGuestRoute?: boolean
}

export default function SiteFooter({ isGuestRoute }: Props): JSX.Element {
  const year = new Date().getFullYear()

  if (isGuestRoute) {
    return (
      <LoginFooter>
        <Container>
          <img alt={'GGB'} src={GGBLogoBasic} />
          <LinkList>
            <li>
              <a href="https://golfgamebook.zendesk.com/hc/en-us" target="_blank" rel="noopener noreferrer">
                <FormattedMessage id={'footer.support'} />
              </a>
            </li>
            <li>
              <a href="https://www.golfgamebook.com/Office-terms-of-use" target="_blank" rel="noopener noreferrer">
                <FormattedMessage id={'footer.termsOfUse'} />
              </a>
            </li>
            <li>
              <a href="https://golfgamebook.com/cookies-policy/" target="_blank" rel="noopener noreferrer">
                <FormattedMessage id={'footer.cookiePolicy'} />
              </a>
            </li>
            <li>
              <a href="https://www.golfgamebook.com/Office-DPA" target="_blank" rel="noopener noreferrer">
                <FormattedMessage id={'footer.DPA'} />
              </a>
            </li>
          </LinkList>
        </Container>
      </LoginFooter>
    )
  }

  return (
    <UserRouteFooter>
      <TextContainer>© {year} Golf Gamebook</TextContainer>
    </UserRouteFooter>
  )
}
